export default __webpack_public_path__ + "static/media/virtual-bg24.65fbf1e5.png";